$(document).ready(function () {

  sendGAEvent('Quiz_event_started', 'Quiz button');

  $(".col_quiz_grid_block").click(function () {
    var currentIndex = $(this).closest(".col_quiz_inner").attr("data-index");
    showNextQuestion(currentIndex);

    var isPoop = $(this).closest(".col_quiz_inner").attr("data-poop");
    var isPoopValue = '';
    if (isPoop == 'true'){
      isPoopValue = $(this).find('.col_quiz_answer').html();
      $('.col_quiz_data').attr('data-poop', isPoopValue);
    }
  });

  $(".col_quiz_btn").click(function () {
    var mode = $(this).attr('data');
    if (mode == 'email_step'){
      var getEmail = String($('.col_quiz_email_collection__js').val());
      
      if (getEmail.indexOf('@') != -1){
        console.log(getEmail);
        sendKlaviyoEmail();
      }

      
    }
    else{
      if ($(this).hasClass("disabled")) {
      } else {
        var currentIndex = $(this).closest(".col_quiz_inner").attr("data-index");
        showNextQuestion(currentIndex);
      }
    }
    
  });

  $(".multiSelect").click(function () {
    var currentAnswer = $(this).attr('data');
    if (currentAnswer == 'none' || currentAnswer == 'prefer-not-to-say'){
      $(this).closest('.col_quiz_grid').find('.multiSelect').removeClass('active');
    }
    else{
      $('.multiSelect[data="none"]').removeClass('active');
      $('.multiSelect[data="prefer-not-to-say"]').removeClass('active');
    }
    $(this).toggleClass("active");
    var allActives = 0;
    $(this)
      .closest(".col_quiz_inner")
      .find(".multiSelect.active")
      .each(function () {
        allActives++;
      });

    if (allActives > 0) {
      $(this)
        .closest(".col_quiz_inner")
        .find(".col_quiz_btn")
        .removeClass("disabled");
    } else {
      $(this)
        .closest(".col_quiz_inner")
        .find(".col_quiz_btn")
        .addClass("disabled");
    }

    console.log(allActives);
  });

  $(".col_quiz_go_back").click(function () {
    var currentIndex = $(".col_quiz_inner.visible").attr("data-index");
    console.log(currentIndex, " current index");
    showPrevQuestion(currentIndex);
  });

  // Function to validate age input
  function validateAgeInput($input) {
    const value = parseInt($input.val()) || 0;
    const $button = $input.closest(".col_quiz_inner").find(".col_quiz_btn");

    if (value >= 18 && value <= 100) {
      $button.removeClass("disabled");
    } else {
      $button.addClass("disabled");
    }
  }

  // Age input validation on keyup
  $(".col_quiz_age_field.age").on("keyup", function () {
    validateAgeInput($(this));
  });

  // Function to check if button should be enabled
  function validateHeightInputs($heightInput) {
    const unit = $heightInput.find(".col_quiz_unit_btn.active").data("unit");
    const $button = $heightInput
      .closest(".col_quiz_inner")
      .find(".col_quiz_btn");

    if (unit === "imperial") {
      // Check if metric input is empty
      const metricValue = $heightInput.find(".metric-wrapper input").val();

      // Get imperial values
      const ftValue = $heightInput.find(".imperial-ft").val();
      const inValue = $heightInput.find(".imperial-in").val();

      // Validate imperial mode
      if (metricValue) {
        // If metric has value while in imperial mode, disable button
        $button.addClass("disabled");
      } else if (ftValue || inValue) {
        // If either ft or in has a value, check if they're valid
        const ft = parseInt(ftValue) || 0;
        const inch = parseInt(inValue) || 0;

        if (
          (ftValue && (ft < 4 || ft > 7)) ||
          (inValue && (inch < 0 || inch > 11))
        ) {
          $button.addClass("disabled");
        } else {
          $button.removeClass("disabled");
        }
      } else {
        // No values entered
        $button.addClass("disabled");
      }
    } else {
      // Get metric value
      const metricValue = $(".col_quiz_age_field.metric").val();
      const cm = parseInt(metricValue) || 0;
      console.log(metricValue, cm, "TESTING ");
      if (metricValue && cm >= 10 && cm <= 250) {
        $button.removeClass("disabled");
      } else {
        $button.addClass("disabled");
      }
    }
  }

  // Unit switch handler
  $(".col_quiz_unit_btn").click(function () {
    const unit = $(this).data("unit");
    const $heightInput = $(this).closest(".col_quiz_Height_input");
    const $metricWrapper = $heightInput.find(".metric-wrapper");
    const $imperialWrapper = $heightInput.find(".imperial-wrapper");
    const $button = $(this).closest(".col_quiz_inner").find(".col_quiz_btn");

    // Update active state
    $(".col_quiz_unit_btn").removeClass("active");
    $('.col_quiz_unit_btn[data-unit="' + unit + '"]').addClass("active");

    // Toggle input wrappers
    if (unit === "imperial") {
      $metricWrapper.hide();
      $imperialWrapper.show();
      $('.col_quiz_age_suffix[data="lb"]').removeClass("hidden");
      $('.col_quiz_age_suffix[data="kg"]').addClass("hidden");
    } else {
      $imperialWrapper.hide();
      $metricWrapper.show();
      $('.col_quiz_age_suffix[data="lb"]').addClass("hidden");
      $('.col_quiz_age_suffix[data="kg"]').removeClass("hidden");
    }

    // Clear all inputs when switching units
    $(this).closest('.col_quiz_inner').find("input").val("");
    // $(".col_quiz_age_field:not(.age)").val("");
    $button.addClass("disabled");
  });

  // Height input validation on keyup
  $(".col_quiz_Height_input input").on("keyup", function () {
    const $heightInput = $(this).closest(".col_quiz_Height_input");
    validateHeightInputs($heightInput);
  });

  // Function to validate weight inputs
  function validateWeightInputs($weightInput) {
    const $button = $weightInput
      .closest(".col_quiz_inner")
      .find(".col_quiz_btn");
    const weight = $weightInput.find(".weight").val();
    const desiredWeight = $weightInput.find(".desired_weight").val();

    if (weight && desiredWeight) {
      $button.removeClass("disabled");
    } else {
      $button.addClass("disabled");
    }
  }

  // Weight input validation on keyup
  $(
    ".col_quiz_Age_input input.weight, .col_quiz_Age_input input.desired_weight"
  ).on("keyup", function () {
    validateWeightInputs($(this).closest(".col_quiz_Age_input"));
  });

 function startLoading(nextIndex) {
    var seconds = 5;

    // clear any previous timer (optional but useful)
    if (window._countdownInterval) {
      clearInterval(window._countdownInterval);
    }

    console.log("Done! timerererere");

    window._countdownInterval = setInterval(function () {
      seconds--;

      if (seconds <= 0) {
        clearInterval(window._countdownInterval);
        window._countdownInterval = null;

        console.log("Done!");
        $('.col_quiz_inner[data-index="' + nextIndex + '"]').find('.col_quiz_button_outer.hidedColQuiz .col_quiz_btn').trigger('click');
      }
    }, 1000);
  }


  function showNextQuestion(currentIndex) {
    var currentIndex = parseFloat(currentIndex);
    var nextIndex = parseFloat(currentIndex) + 1;
    // console.log(nextIndex);

    var isLoader = $('.col_quiz_inner[data-index="' + nextIndex + '"]').attr('data-loading');
    if (isLoader == 'true'){
      startLoading(nextIndex);
    }
    
    var totalQuestions = parseFloat($('.col_quiz_nav_count').attr('data'));
    var nextUrl = $('.col_quiz_outer').attr('data-url');
    if (totalQuestions == currentIndex){
      window.location.href = nextUrl;
    }
    else{
      $(".col_quiz_inner").removeClass("visible");
      $('.col_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");

      var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
      percentage = 100 - percentage;
  
      $(".col_quiz_progress_inner").css("width", percentage + "%");
      $(".col_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    var selectedAge = $('.col_quiz_age_field.age').val();
    var selectedWeight = $('.col_quiz_age_field.weight').val();
    var selectedDesiredWeight = $('.col_quiz_age_field.desired_weight').val();
    var system = $('.col_quiz_unit_btn.active').attr('data-unit');
    var metricHeight = $('.col_quiz_age_field.metric').val();
    var imperialHeightFt = $('.col_quiz_age_field.imperial-ft').val();
    var imperialHeightIn = $('.col_quiz_age_field.imperial-in').val();
    var poop = $('.col_quiz_data').attr('data-poop');
    var gender = '';
    var locationCurrent = String(window.location.href);
    if (locationCurrent.indexOf('gender=female') != -1){
      gender = 'female';
      setCookie("gender", gender, 31);
    }
    else if (locationCurrent.indexOf('gender=male') != -1){
      gender = 'male';
      setCookie("gender", gender, 31);
    }

    $('.col_quiz_data').attr('data-age', selectedAge);
    $('.col_quiz_data').attr('data-weight', selectedWeight);
    $('.col_quiz_data').attr('data-desired-weight', selectedDesiredWeight);
    $('.col_quiz_data').attr('data-system', system);
    $('.col_quiz_data').attr('data-height-metric', metricHeight);
    $('.col_quiz_data').attr('data-height-ft-imperial', imperialHeightFt);
    $('.col_quiz_data').attr('data-height-in-imperial', imperialHeightIn);

    setCookie("age", selectedAge, 31); // Cookie expires in 7 days
    setCookie("weight", selectedWeight, 31);
    setCookie("desired_weight", selectedDesiredWeight, 31);
    setCookie("system", system, 31);
    setCookie("heightMetric", metricHeight, 31);
    setCookie("imperialHeightFt", imperialHeightFt, 31);
    setCookie("imperialHeightIn", imperialHeightIn, 31);
    setCookie("poop", poop, 31);
  
    sendGAEvent('Quiz_event_passed_' + currentIndex + '', 'Quiz button');
    
  }

  function sendGAEvent(eventName, eventLabel) {
      if (!localStorage.getItem(eventName)) {
          gtag('event', eventName, {
              'event_category': 'User Actions',
              'event_label': eventLabel,
              'value': 1,
              'event_timestamp': Date.now()
          });

          console.log(`${eventName} - Sent`);
          localStorage.setItem(eventName, "true"); // Store in localStorage
      } else {
          console.log(`${eventName} - Already Sent (Skipping)`);
      }
  }

  function setCookie(name, value, days) {
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + encodeURIComponent(value) + "; path=/;" + expires;
  }

  function showPrevQuestion(currentIndex) {
    if (currentIndex > 1) {
      var nextIndex = parseFloat(currentIndex) - 1;
      console.log(nextIndex);
      $(".col_quiz_inner").removeClass("visible");
      $('.col_quiz_inner[data-index="' + nextIndex + '"]').addClass("visible");

      var totalQuestions = 15;
      var percentage = ((totalQuestions - nextIndex) * 100) / totalQuestions;
      percentage = 100 - percentage;

      $(".col_quiz_progress_inner").css("width", percentage + "%");
      $(".col_quiz_nav_count").html(nextIndex + " of " + totalQuestions);
    }
  }


  function sendKlaviyoEmail(){
    var email = $('.col_quiz_email_collection__js').val();
    console.log(email);
    var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
        },
        "data": {
            "g": "VeHDGj",
            "email": email,
            "$fields": "$source, $last_name",
            "$source": "Account Creation",
        }
    };

    $.ajax(settings)
            .done(function(response) {
                console.log("Klaviyo Response:", response);
                $('.col_quiz_email_btn_text').html('SUCCESSS!');
                sendGAEvent('Quiz_event_passed_email_step', 'Quiz button');
                var nextUrl = $('.col_quiz_email--data').attr('data-url');
                window.location.href = nextUrl;
            })
            .fail(function(xhr, textStatus, errorThrown) {
                console.error("Klaviyo Error:", xhr.responseText || textStatus || errorThrown);
    });
  }


  $('.col_quiz_loading_reviews').slick({
    infinite: true,
    slidesToShow: 1, 
    arrows: false, 
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000
  });
  
});


